import { Component, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { V6FrameConfigMode } from '../../../../../../core/enums';
import { IProductTemplate } from '../../../../../../core/models';
import { V6productService } from '../../../../../../core/services/v6product.service';

@Component({
  selector: 'app-manage-frame',
  templateUrl: './manage-frame.component.html',
  styleUrls: ['./manage-frame.component.scss']
})
export class ManageFrameComponent implements OnInit {

  productModel: IProductTemplate;

  constructor(private v6ProductService: V6productService) {
    this.productModel = this.v6ProductService.productModel;
  }

  ngOnInit() {
  }

  //#region Navigation
  goToFrameConfig(action: string, frameIndex: number) {
    switch (action) {
      case 'editResourceFrame':
        this.v6ProductService.frameConfigMode = V6FrameConfigMode.EDIT_RESOURCE_FRAME
        this.v6ProductService.configFormIndex = 3;
        break;
      case 'addResourceFrame':
        this.v6ProductService.frameConfigMode = V6FrameConfigMode.ADD_RESOURCE_FRAME
        this.v6ProductService.configFormIndex = 3;
        break;
      case 'editNestedFrame':
        this.v6ProductService.frameConfigMode = V6FrameConfigMode.EDIT_NESTED_FRAME
        this.v6ProductService.nestedFrameIndexInEditMode = frameIndex;
        this.v6ProductService.configFormIndex = 3;
        break;
      case 'addNestedFrame':
        this.v6ProductService.frameConfigMode = V6FrameConfigMode.ADD_NESTED_FRAME
        this.v6ProductService.configFormIndex = 3;
        break;
      default: break;
    }

  }
  goBack() {
    this.v6ProductService.configFormIndex = 1;
  }
  //#endregion

  removeNestedFrame(nestedFrameIndex){
    //Length Checking
    this.productModel.nestedFrames.splice(nestedFrameIndex,1);
  }
  duplicateNestedFrame(editNestedFrame ,nestedFrameIndex):void{
    const duplicateFrame=this.productModel.nestedFrames[nestedFrameIndex];
    this.productModel.nestedFrames.push(cloneDeep(duplicateFrame));
  }
}
